module.exports = __webpack_public_path__ + "site/img/team_member_Yvonne.f4f9285c.jpg";